export * from './lib/approve-dialog.module';
export * from './lib/approve-dialog.component';
